import { render, staticRenderFns } from "./property-drawer.vue?vue&type=template&id=2878e801&"
import script from "./property-drawer.vue?vue&type=script&lang=ts&"
export * from "./property-drawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports